import React, {useEffect, useState} from 'react';
import localization from "../../../../assets/localization/localization";
import Layout from 'components/sales/layout/layout';
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import {Button} from "react-bootstrap";
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import CustomModal from "../../../valetServices/modal";
import {toast} from "react-toastify";

const SiteRepository = (
    {
        match,
        documentUploadUrlPublic,
        documentUrlDataPublic,
        siteRepository,
        getSiteRepository,
        getSiteRepositoryDetails,
        createSiteRepository
    }
) => {


    const [isLoading, setIsLoading] = useState(false);
    const [inputImage, setImageList] = useState([{url: "", content: ""}]);
    const [siteTypeImage, setSiteTypeImage] = useState(
        [
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}
        ]
    );
    const [listData, setRepositoryData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [count, setCount] = useState(0)
    const [fileExt, setFileExt] = useState("")
    const [nonMandateArray, setNonMandateArray] = useState(['Snaps','Others','Videos','BRD','WPR','Warranty Certificate'])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getSiteRepository(match.params.id);
            setIsLoading(false)
        })()
    }, [])

    const headers = ['Media', 'Description', 'Created On'];

    useEffect(() => {
        const tableData = ['doc_type', 'description', 'created_at'];
        if (getSiteRepositoryDetails && Object.keys(getSiteRepositoryDetails).length > 0) {
            setSiteTypeImage([])
            if (getSiteRepositoryDetails?.required_document) {
                setSiteTypeImage(getSiteRepositoryDetails?.required_document)
            }

            const data = getSiteRepositoryDetails?.data.map((element) =>

                Object.assign(
                    {},
                    ...tableData.map((key) => (
                        key === 'doc_type' && element[key] === 'png' ? {
                                [key]: <a href={element['url']} target="_blank"><img src={element['url']} style={{
                                    "width": "48px",
                                    "borderRadius": "16px",
                                    "height": "48px"
                                }}/></a>
                            } :
                            key === 'doc_type' && element[key] === 'jpeg' ? {
                                    [key]: <a href={element['url']} target="_blank"><img src={element['url']} style={{
                                        "width": "48px",
                                        "borderRadius": "16px",
                                        "height": "48px"
                                    }}/></a>
                                } :
                                key === 'doc_type' && element[key] === 'jpg' ? {
                                        [key]: <a href={element['url']} target="_blank"><img src={element['url']} style={{
                                            "width": "48px",
                                            "borderRadius": "16px",
                                            "height": "48px"
                                        }}/></a>
                                    } :
                                    key === 'doc_type' && element[key] === 'doc' ? {
                                            [key]: <a href={element['url']} target="_blank"><img src={Images?.DocIcon}
                                                                                                 alt=""
                                                                                                 className="view-icon"/></a>
                                        } :
                                        key === 'doc_type' && element[key] === 'pdf' ? {
                                                [key]: <a href={element['url']} target="_blank"><img src={Images?.DocIcon}
                                                                                                     alt=""
                                                                                                     className="view-icon"/></a>
                                            } :
                                            key === 'doc_type' ? {
                                                    [key]: <a href={element['url']} target="_blank"><img
                                                        src={Images?.DocIcon}
                                                        alt=""
                                                        className="view-icon"/></a>
                                                } :
                                                {[key]: element[key]})),
                )
            );
            data && setRepositoryData(data);
            setPageCount(Math.ceil(getSiteRepositoryDetails.total / getSiteRepositoryDetails.per_page));
        }
    }, [getSiteRepositoryDetails]);


    const onPageChange = async (val) => {
        setIsLoading(true);
        getSiteRepository(match.params.id, val.selected + 1);
        setIsLoading(false);
    };

    const handleImageContent = (val, index) => {
        const list = [...inputImage]
        list[index]['content'] = val
        setImageList([...list])
    }

    const saveImage = (val, index) => {
        const list = [...inputImage]
        list[index]['url'] = val
        setImageList([...list])
    }

    const handleSiteTypeImageContent = (val, index) => {
        const list = [...siteTypeImage]
        list[index]['content'] = val
        setSiteTypeImage([...list])
    }

    const saveSiteTypeImage = (val, index) => {
        const list = [...siteTypeImage]
        list[index]['url'] = val
        setSiteTypeImage([...list])
    }

    const handleImageAdd = () => {
        setImageList(
            [
                ...inputImage, {
                url: '',
                content: ''
            }
            ]
        )
    }

    const handleImageRemove = index => {
        const list = [...inputImage];
        list.splice(index, 1);
        setImageList(list);
    }

    const handleSubmit = async () => {
        let isBroken = false;
        siteTypeImage.map((x, i) => {
            if (x?.url === "" && !isBroken && x?.content !== 'Videos') {
                // toast.error("Document is required for " + x?.content);
                // isBroken = true
            }
        })

        if (isBroken) {
            return false
        }

        let data = {
            'site_id': match.params.id,
            'image_url': inputImage,
            'required_document': siteTypeImage
        }

        setIsLoading(true)
        let res = await siteRepository(data)
        setCount(count + 1)
        setIsLoading(false)
    }

    return (
        <Layout
            title={localization.siteRepository}
            isLoading={isLoading}
            isGoback={true}
        >
            <>
                <div className="container-fluid mb-0">
                    <div className="card">
                        {createSiteRepository !== null && createSiteRepository?.response?.status !== 200 &&
                            <CustomModal msg={createSiteRepository?.response?.message} click={count}/>}
                        {createSiteRepository !== null && createSiteRepository?.response?.status === 200 &&
                            <CustomModal msg={createSiteRepository?.response?.message} isPageLoad={true}
                                         click={count}/>}
                        <div className="card-header">
                            {localization.addSiteRepository}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                {siteTypeImage.map((x, i) => {
                                    // return true
                                    return (
                                        <>
                                            <div className="col-md-5">
                                                <ConstantInput
                                                    label={localization.documentType}
                                                    type="text"
                                                    value={x?.content}
                                                    handleChange={(val) => {
                                                        handleSiteTypeImageContent(val, i);
                                                    }}
                                                    required
                                                    isStarRequired={nonMandateArray.includes(x?.content) ? false : true}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col-md-2 mr-1">
                                                <FileUpload
                                                    id={"addAttachment" + i + 1}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) =>
                                                        saveSiteTypeImage(val, i)
                                                    }
                                                    prefilledFilename={x?.url ? 'uploaded' : ""}
                                                >
                                                        <span className="btn btn-transparent">
                                                            {localization.media}
                                                        </span>
                                                </FileUpload>
                                            </div>
                                            {x?.url &&
                                                <div className="col-md-2">
                                                    {
                                                        x?.url.split('.').pop() === 'png' ? <img src={x?.url} style={{
                                                                "width": "80px",
                                                                "borderRadius": "16px",
                                                                "height": "57px"
                                                            }}/> :
                                                            x?.url.split('.').pop() === 'jpeg' ? <img src={x?.url}
                                                                                                      style={{
                                                                                                          "width": "80px",
                                                                                                          "borderRadius": "16px",
                                                                                                          "height": "57px"
                                                                                                      }}/> :
                                                                x?.url.split('.').pop() === 'jpg' ? <img src={x?.url}
                                                                                                         style={{
                                                                                                             "width": "80px",
                                                                                                             "borderRadius": "16px",
                                                                                                             "height": "57px"
                                                                                                         }}/> :
                                                                    x?.url.split('.').pop() === 'pdf' ?
                                                                        <img src={Images?.DocIcon} alt=""
                                                                             className="view-icon"/> :
                                                                        x?.url.split('.').pop() === 'doc' ?
                                                                            <img src={Images?.DocIcon} alt=""
                                                                                 className="view-icon"/> :
                                                                            x?.url.split('.').pop() === 'mp4' ?
                                                                                <video width="120" height="80" controls>
                                                                                    <source src={x?.url}
                                                                                            type="video/mp4"></source>
                                                                                </video> :
                                                                                x?.url.split('.').pop() === 'webm' ?
                                                                                    <video width="120" height="80"
                                                                                           controls>
                                                                                        <source src={x?.url}
                                                                                                type="video/mp4"></source>
                                                                                    </video> :
                                                                                    x?.url.split('.').pop() === 'mkv' ?
                                                                                        <video width="120" height="80"
                                                                                               controls>
                                                                                            <source src={x?.url}
                                                                                                    type="video/mp4"></source>
                                                                                        </video> :
                                                                                        ""
                                                    }
                                                </div>
                                            }
                                        </>
                                    );
                                })}
                            </div>
                            <div className="row">
                                {inputImage.map((xx, i) => {
                                    return (
                                        <>
                                            <div className="col-md-5">
                                                <ConstantInput
                                                    label={localization.description}
                                                    type="text"
                                                    value={xx?.content}
                                                    handleChange={(val) => {
                                                        handleImageContent(val, i);
                                                    }}
                                                    required
                                                    //isStarRequired={true}
                                                />
                                            </div>
                                            <div className="col-md-2">
                                                <FileUpload
                                                    id={"addAttachment" + i}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) =>
                                                        saveImage(val, i)
                                                    }
                                                    prefilledFilename={xx?.url ? 'Image uploaded' : ""}
                                                >
                                                        <span className="btn btn-transparent">
                                                            {localization.image}
                                                        </span>
                                                </FileUpload>
                                            </div>
                                            {xx?.url &&
                                                <div className="col-md-2">
                                                    {
                                                        xx?.url.split('.').pop() === 'png' ? <img src={xx?.url} style={{
                                                                "width": "80px",
                                                                "borderRadius": "16px",
                                                                "height": "57px"
                                                            }}/> :
                                                            xx?.url.split('.').pop() === 'jpeg' ? <img src={xx?.url}
                                                                                                       style={{
                                                                                                           "width": "80px",
                                                                                                           "borderRadius": "16px",
                                                                                                           "height": "57px"
                                                                                                       }}/> :
                                                                xx?.url.split('.').pop() === 'jpg' ? <img src={xx?.url}
                                                                                                          style={{
                                                                                                              "width": "80px",
                                                                                                              "borderRadius": "16px",
                                                                                                              "height": "57px"
                                                                                                          }}/> :
                                                                    xx?.url.split('.').pop() === 'pdf' ?
                                                                        <img src={Images?.DocIcon} alt=""
                                                                             className="view-icon"/> :
                                                                        xx?.url.split('.').pop() === 'doc' ?
                                                                            <img src={Images?.DocIcon} alt=""
                                                                                 className="view-icon"/> :
                                                                            xx?.url.split('.').pop() === 'mp4' ?
                                                                                <video width="120" height="80" controls>
                                                                                    <source src={xx?.url}
                                                                                            type="video/mp4"></source>
                                                                                </video> :
                                                                                xx?.url.split('.').pop() === 'webm' ?
                                                                                    <video width="120" height="80"
                                                                                           controls>
                                                                                        <source src={xx?.url}
                                                                                                type="video/mp4"></source>
                                                                                    </video> :
                                                                                    xx?.url.split('.').pop() === 'mkv' ?
                                                                                        <video width="120" height="80"
                                                                                               controls>
                                                                                            <source src={xx?.url}
                                                                                                    type="video/mp4"></source>
                                                                                        </video> :
                                                                                        ""
                                                    }
                                                </div>
                                            }
                                            {inputImage.length !== 1 &&
                                                <div className="col-md-1">
                                                    <button
                                                        onClick={() => handleImageRemove(i)}
                                                        className="mr10 btn btn-sm btn-danger">Remove
                                                    </button>
                                                </div>
                                            }
                                            {inputImage.length - 1 === i &&
                                                <div className="col-md-2">
                                                    <button className="btn btn-sm btn-primary"
                                                            onClick={handleImageAdd}>Add
                                                    </button>
                                                </div>
                                            }
                                        </>
                                    );
                                })}
                                <div className="col-md-12">
                                    <center><Button onClick={handleSubmit}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="card mt-2">
                        <div className="card-header">
                            {localization.siteRepositoryListing}
                        </div>
                        <div className="card-header">
                            <div className="card-body">
                                <TableSection
                                    data={listData}
                                    isId={false}
                                    isMngId={false}
                                    headers={headers}
                                    pageCount={pageCount}
                                    onPageChange={onPageChange}
                                    onChange={() => {
                                    }}
                                    detailList={listData && listData}
                                    srNo={getSiteRepositoryDetails?.from}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </Layout>
    )
}

export default SiteRepository